import Equalizer from 'equalizer';

export default {
  inserted(el, binding) {
    let elements = binding.value ? el.querySelectorAll(binding.value) : el.children;
    let eq = Equalizer(elements);

    eq.align();
    binding.def.sizeElements(elements);

    setTimeout(() => {
      binding.def.resetElements(elements);
      eq.align();
      binding.def.sizeElements(elements);
    }, 1000);

    window.addEventListener('resize', _.debounce(() => {
      binding.def.resetElements(elements);
      eq.align();
      binding.def.sizeElements(elements);
    }, 100));
  },

  resetElements(elements) {
    [...elements].forEach(element => {
      element.style.height = 'initial';
      element.style.minHeight = 'initial';
    });
  },

  sizeElements(elements) {
    [...elements].forEach(element => {
      element.style.height = element.style.minHeight;
    });
  }
};
